export class EmployeeRequest{
    employeeId:number;
    
    constructor(employeeId:number){
        this.employeeId = employeeId;
    }
}